import React from "react";

import PublicLayout from "@/components/layouts/NotAuthenticated/PublicLayout";
import { ErrorCard } from "@/components/organisms";

export type ErrorPageProps<ErrorType> = {
    error?: ErrorType;
};
const ErrorPage = <ErrorType extends Error & { code?: string }>({
    error,
}: ErrorPageProps<ErrorType>): React.ReactElement => {
    return (
        <PublicLayout>
            <ErrorCard error={error} refreshButton />
        </PublicLayout>
    );
};
export default ErrorPage;
